module.exports = __webpack_public_path__ + "media/Loops Perc.40abeaa7.wav";